export default __webpack_public_path__ + "static/8-946935591dd2354ae71ae4a688529e3f.png";